@if (type) {
    <div class="row">
        <div class="field">
            <lm-lookup-basic #lmMetricLookupField1
                             [fieldLabel]="metricLabel1"
                             [sourceField]="sourceField"
                             [selectListUrl]="metricSelectUrl"
                             [dataView]="dataView"
                             [viewType]="'list'"
                             [viewName]="sourceField"
                             (lookupValueChangedEvent)="handleMetric1LookupValueChanged($event)"
            >
            </lm-lookup-basic>
        </div>
        @if (!disallowMeasureOverride) {
            <div class="field">
                <input
                    soho-checkbox
                    type="checkbox"
                    id="lm-add-to-metric-measure-1-checkbox"
                    name="lm-add-to-metric-measure-1-checkbox"
                    data-automation-id="lm-add-to-metric-measure-1-checkbox"
                    [(ngModel)]="showMeasure1"
                >
                <label
                    soho-label
                    for="lm-add-to-metric-measure-1-checkbox"
                    [forCheckBox]="true">{{'OverrideMeasure1' | translate}}</label>
            </div>
            @if (showMeasure1) {
                <div class="field lm-override-measure-field-1">
                    <lm-field-picker-lookup
                      #lmMeasureLookupField1
                      [fieldLabel]="measureLabel1"
                      [fieldPickerSelectOptions]="measurePickerOptions"
                      [fieldPickerUrl]="measureSelectUrl"
                      (lookupValueChangedEvent)="handleMeasure1LookupValueChanged($event)"
                    >
                    </lm-field-picker-lookup>
                </div>
            }
        }
    </div>

    <hr class="lm-add-to-metric-compute-dialog-hr" style="margin-top: 20px; margin-bottom: 20px;">

    <div class="row">
        <div class="field">
            <lm-lookup-basic #lmMetricLookupField2
                             [fieldLabel]="metricLabel2"
                             [sourceField]="sourceField"
                             [selectListUrl]="metricSelectUrl"
                             [dataView]="dataView"
                             [viewType]="'list'"
                             [viewName]="sourceField"
                             (lookupValueChangedEvent)="handleMetric2LookupValueChanged($event)"
            >
            </lm-lookup-basic>
        </div>
        @if (!disallowMeasureOverride) {
            <div class="field">
                <input
                    soho-checkbox
                    type="checkbox"
                    id="lm-add-to-metric-measure-2-checkbox"
                    name="lm-add-to-metric-measure-2-checkbox"
                    data-automation-id="lm-add-to-metric-measure-2-checkbox"
                    [(ngModel)]="showMeasure2"
                >
                <label
                    soho-label
                    for="lm-add-to-metric-measure-2-checkbox"
                    [forCheckBox]="true">{{'OverrideMeasure2' | translate}}</label>
            </div>
            @if (showMeasure2) {
                <div class="field lm-override-measure-field-2">
                    <lm-field-picker-lookup
                      #lmMeasureLookupField2
                      [fieldLabel]="measureLabel2"
                      [fieldPickerSelectOptions]="measurePickerOptions"
                      [fieldPickerUrl]="measureSelectUrl"
                      (lookupValueChangedEvent)="handleMeasure2LookupValueChanged($event)"
                    >
                    </lm-field-picker-lookup>
                </div>
            }
        }
    </div>
}